// extracted by mini-css-extract-plugin
export var cartContainer = "_il-4";
export var gray = "_il-1";
export var itemContainer = "_il-2";
export var itemDetails = "_il-3";
export var strong = "_il-0";